export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于久久影视</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            专注电视剧全集免费在线观看的平台
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20large%20TV%20screen%20displaying%20abstract%20colorful%20entertainment%20visuals%2C%20soft%20ambient%20lighting%20with%20golden%20and%20coral%20warm%20tones%2C%20comfortable%20modern%20interior%20with%20plants%20and%20textiles%2C%20cinematic%20atmosphere%2C%20editorial%20lifestyle%20photography%20with%20rich%20textures%20and%20cozy%20vibes&width=1200&height=800&seq=about-visual-jiujiu&orientation=landscape"
                  alt="久久影视平台介绍"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
            <div className="flex-1 space-y-5">
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                久久影视成立于 2020 年，是一个专注电视剧全集免费在线观看的平台。我们致力于为广大剧迷提供最便捷、最高清的追剧体验——<strong>热门国产剧全集</strong>、<strong>韩剧全集在线</strong>观看，无需等待更新，一次性畅享完整剧情。
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                平台汇聚了数千部电视剧资源，涵盖古装、悬疑、甜宠、都市、奇幻等多元类型，每日更新超过 30 部剧集内容，确保用户总能找到心仪的好剧。我们采用先进的高清秒播技术，为你呈现流畅不卡顿的观影享受。
              </p>
              <div className="flex gap-4 pt-2">
                <div className="text-center">
                  <div className="text-2xl font-heading text-primary-500">5000+</div>
                  <div className="text-xs text-foreground-500 mt-1">电视剧资源</div>
                </div>
                <div className="w-px bg-background-200"></div>
                <div className="text-center">
                  <div className="text-2xl font-heading text-accent-500">800万+</div>
                  <div className="text-xs text-foreground-500 mt-1">活跃剧迷</div>
                </div>
                <div className="w-px bg-background-200"></div>
                <div className="text-center">
                  <div className="text-2xl font-heading text-secondary-500">99.7%</div>
                  <div className="text-xs text-foreground-500 mt-1">播放成功率</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}